import { createFileRoute } from "@tanstack/react-router";

import { legalRoute } from "./legal/-components/legalRoute";

export const Route = createFileRoute(
  "/privacy-notice-for-eea-switzerland-and-uk"
)(legalRoute("privacy-notice-for-eea-switzerland-and-uk"));
